import type { FunctionComponent } from 'react';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';

import { getMarketingScreenInfo } from 'app/src/getMarketingScreenInfo';
import { PowerUpsList } from './PowerUpsList';
import type { Plugins } from './types';

interface AllPageProps {
  readonly plugins: Plugins;
}

export const AllPage: FunctionComponent<AllPageProps> = ({ plugins }) => {
  const intl = useIntl();

  useEffect(() => {
    const { url, referrerUrl, referrerScreenName } = getMarketingScreenInfo();
    Analytics.sendMarketingScreenEvent({
      url,
      referrerUrl,
      referrerScreenName,
      event: {
        source: 'publicDirectoryAllCategoriesScreen',
        name: 'publicDirectoryAllCategoriesScreenV2',
        attributes: {
          totalListed: plugins.length,
        },
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <PowerUpsList
      title={intl.formatMessage({
        id: 'templates.directory.power-ups',
        defaultMessage: 'Power-Ups',
        description: 'Title for the Power-Ups list',
      })}
      plugins={_.shuffle(plugins)}
    />
  );
};
